export default {
    checked: Boolean, 
    enable: Boolean, 
    offLabel: String, 
    onLabel: String, 

    // Events
    change: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoSwitch/SwitchProps.js